<template>
  <div id="app" class="flex flex-wrap background-gray" @click="handleBodyClick">
    <template v-if="router === '/login' || router === '/priceComparison'">
		<router-view ></router-view>
	</template>
	<template v-else>
		<v-header></v-header>
		<left-nav></left-nav>
		<div class="container">
			<!-- 页头-->
			<tab-list></tab-list>
			<!--面包屑-->
			<crumbs></crumbs>
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</div>
	</template>
  </div>
</template>

<script>
import vHeader from './components/header.vue' //一级菜单
import leftNav from './components/nav.vue' //左侧菜单
import tabList from './components/tabList.vue' //顶部第二行，已打开菜单
import crumbs from './components/crumbs.vue' //面包屑导航
export default {
  name: 'App',
    provide () {
	    return {
		  reload: this.reload
	   }
   },
    components: {
	  vHeader, leftNav, tabList, crumbs
    },
   watch: {
	   $route (to, from) {
		   this.judgePath()
			//根据理由长度判断是否刷新页面
			let toArr = to.fullPath.split('/'), fromArr = from.fullPath.split('/')
			if (to.path === '/navManage') {
				// 如果路由为角色管理，则不缓存路由
				to.meta.keepAlive = false
			} else {
				if (toArr.length > fromArr.length) {
					this.reload()
					to.meta.keepAlive = false
				} else {
					to.meta.keepAlive = true
				}
			}
			this.setView(to)
			if (toArr[1] === fromArr[1] && toArr.length < fromArr.length) {
				//当前路由=上一个路由，表示在同一模块跳转 && 当前路由长度<上一个路由长度，说明由详情页到列表页   ，需要清除已保留详情页数据
				this.removeCrumbs(to) //移除详情页数据
			} else {
				//当前路由!=上一个路由，表示不同模块之间跳转，需要保留详情页数据 || 当前路由长度>上一个路由长度，说明列表页跳转详情页，需要保留详情页数据
				this.setCrumbs(to) //判断加上详情
			}
			
		}
  	},
  	data () {
	  	return {
			router: this.$route.path,
			isRouterAlive: true
	  	}
  	},
  	methods: {
	  	judgePath () {
		  	this.router = this.$route.path;
			  console.log('this.router',this.router)
		  	if ((this.router !== '/login' && this.router !== '/priceComparison') && sessionStorage.getItem('token') == null) {
			    this.error('检测到未登录');
				this.goPath('/login');
		  	}
	  	},
	  	reload () {
		  this.$route.meta.keepAlive = false
			this.$nextTick(() => {
				this.$route.meta.keepAlive = true
			})
	  	},
	  //设置导航、面包屑
	  	setView (path) {
		   let curPath = path.path.split('/')[1], cur = {}, isNew = true
			this.$root.Permission.forEach(element => { //初始化全不选
				element.active = false
				element.item.forEach(el => {
					el.active = false
					el.item.forEach(e => {
						e.active = false
					})
				})
			})
			let element = this.$root.Permission
            for (let i = 0; i < element.length; i++) {//判断选中
                if (Array.isArray(element[i].item)) {
                    for (let j = 0; j < element[i].item.length; j++) {
                        if (Array.isArray(element[i].item[j].item)) {
                            for (let k = 0; k < element[i].item[j].item.length; k++) {
                                if (element[i].item[j].item[k].url.split('/')[1] === curPath) {
                                    element[i].item[j].item[k].active = true
                                    element[i].item[j].active = true
                                    element[i].active = true
                                    break
                                }
                            }
                        }
                        if (element[i].item[j].active) break
                    }
                }
                if (element[i].active) break
            }
			//判断是否已打开过路由
			this.$root.openNav.forEach(el => {
				if (el.id === cur.id) {
					isNew = false
				}
			})
			// if (isNew) {
			// 	this.$root.openNav.push(cur)
			// }
		},
		setCrumbs (to) {
			//添加详情
			let newArr = to.fullPath.split('/');
			this.$root.openNav.forEach( el => {
				if (newArr[1] === el.url.split('/')[1] && el.chirld === undefined) {
					el.chirld = to.fullPath;
				}
			})
		},
		removeCrumbs (to) {
			let toArr = to.path.split('/');
			this.$root.openNav.forEach( el => {
				if (toArr[1] === el.url.split('/')[1]) {
					delete el['chirld']
				}
			})
		},
		handleBodyClick() {
			this.$root.isShowHeaderOpera = false;	//隐藏头部右侧修改密码和退出登录列表
		}
	},
	mounted () {
		this.judgePath();
	}
	  
}
</script>

<style scope>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	min-height: 100vh;
	width: 100%;
}
#app>.container{width: calc(100% - 184px);}
#postManage .tab .el-table .cell{padding-left:35px;}
.el-input--small .el-input__inner{height: 30px; line-height: 30px; border-radius: 2px;}
.el-date-editor--daterange.el-input__inner{width: 213px;}
.el-range-editor--small .el-range-separator{line-height: 24px;}
.el-range-editor--small.el-input__inner{height: 30px; border-radius: 2px;}
.el-button--primary{border-radius: 2px;background: #2480ED;}
.el-button--small{padding: 8px 15px;}
.el-button--text{color: #2480ED}
.el-form-item.last-form-item{margin-bottom: 0;}
.el-dialog__body{padding: 20px;}
</style>



// WEBPACK FOOTER //
// src/App.vue